import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewCollection from './components/NewCollection';
import EditCollection from './components/EditCollection';
import CollectionsList from './components/CollectionsList';

const Collections = () => {
    const [listRequiresReload, setListRequiresReload] = useState(true);
    const [selectedCollection, setSelectedCollection] = useState();

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Collections Management</h3>
                    <h3 className="page-subhead subhead">Manage workspace collections</h3>
                </Col>
            </Row>
            <Row>
                <Col md={8}>
                    <CollectionsList setSelectedCollection={setSelectedCollection} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
                </Col>
                <Col md={4}>
                    {!selectedCollection && <NewCollection setSelectedCollection={setSelectedCollection} setListRequiresReload={setListRequiresReload} selectedCollection={selectedCollection} />}
                    {selectedCollection && <EditCollection setSelectedCollection={setSelectedCollection} setListRequiresReload={setListRequiresReload} selectedCollection={selectedCollection} />}
                </Col>
            </Row>
        </Container>
    );
};

export default Collections;